import React from 'react';
import { Box, Stack, Typography, Button, Container } from '@mui/material';
import { alpha } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const SuccessInfo = () => {
    const ticket = 'COCO-2026-001'; // 实际使用时可从路由参数或 props 获取

    return (
        <Box
            sx={{
                minHeight: '100vh',
                width: '100%',
                backgroundColor: '#EFDDD0',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Container maxWidth="sm">
                <Stack
                    spacing={4}
                    alignItems="center"
                    sx={{
                        backgroundColor: '#fff',
                        borderRadius: 2,
                        padding: { xs: 4, sm: 6 },
                        boxShadow: 3,
                        textAlign: 'center',
                    }}
                >
                    {/* 成功图标 */}
                    <CheckCircleIcon
                        sx={{
                            fontSize: 80,
                            color: '#EF7F95',
                            '&:hover': {
                                color: alpha('#EF7F95', 0.8)
                            },
                        }}
                    />

                    {/* 标题 */}
                    <Typography
                        variant="h4"
                        component="h1"
                        sx={{
                            fontWeight: 700,
                            color: '#333',
                        }}
                    >
                        购买成功！
                    </Typography>

                    {/* 订单信息 */}
                    <Stack
                        spacing={2}
                        sx={{
                            width: '100%',
                            textAlign: 'left',
                        }}
                    >
                        <Typography
                            variant="body1"
                            sx={{
                                color: '#2e6c80',
                                lineHeight: 1.8,
                                fontSize: 16,
                            }}
                        >
                            🎉亲爱的 coco 学员，
                        </Typography>

                        <Typography
                            variant="body1"
                            sx={{
                                color: '#666',
                                lineHeight: 1.8,
                                fontSize: 16,
                            }}
                        >
                            感谢您购买我的课程服务！
                        </Typography>

                        <Typography
                            variant="body1"
                            sx={{
                                color: '#666',
                                lineHeight: 1.8,
                                fontSize: 16,
                            }}
                        >
                            <strong>【订单号】:</strong>{' '}
                            <span style={{ color: '#2e6c80' }}>{ticket}</span>
                        </Typography>

                        <Typography
                            variant="body1"
                            sx={{
                                color: '#666',
                                lineHeight: 1.8,
                                fontSize: 16,
                            }}
                        >
                            <strong>【excel ai 工具教程】:</strong><br />
                            <a
                                href="https://pan.quark.cn/s/947a2aa0eea3"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#EF7F95', textDecoration: 'none' }}
                            >
                                点击查看完整教程
                            </a><br />
                            这是超级重要的准备步骤哦～必须先把这些看完才能真正上手玩转 ai 呀！😉
                        </Typography>

                        <Typography
                            variant="body1"
                            sx={{
                                color: '#666',
                                lineHeight: 1.8,
                                fontSize: 16,
                            }}
                        >
                            <strong>【✨ excel ai 工具】:</strong><br />
                            <a
                                href="https://mica.mindlink.tools/download/install.exe"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#EF7F95', textDecoration: 'none' }}
                            >
                                点击下载
                            </a><br />
                            怕大家做表格太辛苦，找了个 excel ai 神器 mica 给大家哈，按照教程下载安装，快去体验一下吧😘
                        </Typography>
                    </Stack>

                    {/* 分隔线 */}
                    <Box
                        sx={{
                            width: '100%',
                            height: '1px',
                            backgroundColor: '#eee',
                            my: 1,
                        }}
                    />

                    {/* Excel AI 助手链接 */}
                    <Button
                        variant="contained"
                        fullWidth
                        href="https://mica.mindlink.tools/download/install.exe"
                        target="_blank"
                        rel="noopener noreferrer"
                        startIcon={<AutoAwesomeIcon />}
                        sx={{
                            backgroundColor: '#EF7F95',
                            color: '#fff',
                            height: 48,
                            fontSize: 16,
                            fontWeight: 600,
                            borderRadius: 2,
                            textTransform: 'none',
                            '&:hover': {
                                backgroundColor: alpha('#EF7F95', 0.8),
                            },
                        }}
                    >
                        下载 Excel AI 助手
                    </Button>

                    {/* 返回首页按钮 */}
                    <Button
                        variant="outlined"
                        fullWidth
                        href="/"
                        startIcon={<ArrowBackIcon />}
                        sx={{
                            color: '#EF7F95',
                            borderColor: '#EF7F95',
                            height: 48,
                            fontSize: 16,
                            borderRadius: 2,
                            textTransform: 'none',
                            '&:hover': {
                                borderColor: alpha('#EF7F95', 0.8),
                                backgroundColor: alpha('#EF7F95', 0.05),
                            },
                        }}
                    >
                        返回首页
                    </Button>
                </Stack>
            </Container>
        </Box>
    );
};

export default SuccessInfo;
